import { Icon } from '@components/icon/Icon';
import typography from '~styles/typography.scss';
import cx from 'classnames';
import styles from './VipPricingBanner.scss';

export interface VipPricingBannerProps {
  variant: 'applied' | 'available';
}

export const VipPricingBanner = ({ variant }: VipPricingBannerProps) => (
  <div className={styles.banner} data-testid="vip-pricing-banner">
    <Icon className={styles.icon} fill="var(--gold)" name="star" />
    <span className={cx(typography.h7m, styles.text)}>
      {variant === 'applied'
        ? 'VIP Exclusive Pricing Applied'
        : 'VIP Exclusive Pricing Available'}
    </span>
  </div>
);
